import type { ComponentStyleConfig } from '@chakra-ui/theme';

const AccordionTheme: ComponentStyleConfig = {
  baseStyle: {
    button: {
      _hover: {
        background: 'background/hover',
      },
      _active: {
        background: 'background/active',
      },
      textStyle: 'body/lg/regular',
      _expanded: {
        textStyle: 'body/lg/semibold',
      },
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'space-between',
      padding: '16',
      width: '100%',
    },
    icon: {
      height: '24',
      marginLeft: '16',
      width: '24',
    },
    item: {
      borderTop: '1px solid',
      borderTopColor: 'border/regular',
    },
    panel: {
      paddingInline: '16',
      paddingTop: '8',
      paddingBottom: '24',
    },
    root: {
      borderBottom: '1px solid',
      borderBottomColor: 'border/regular',
    },
  },
};

export default AccordionTheme;
